<template>
    <v-btn   :dark="!isDisabled"
            :to="toRouter"
            :icon="$vuetify.breakpoint.smAndDown || isCircular"
            medium
            :disabled="isDisabled"
            :text="text"
            @click="click($event)"
            :color="color">
        <v-icon  :left="$vuetify.breakpoint.mdAndUp && !isCircular">
            {{$vuetify.breakpoint.mdAndUp? defaultIcon:smallIcon}}
        </v-icon>
        <slot v-if="$vuetify.breakpoint.mdAndUp && !isCircular "></slot>
    </v-btn>
</template>

<script>
    export default {
        name: "LogOut",
        props:['setCircular', "setColor", "setClick",
            "setDefaultIcon", "setSmallIcon", "setTo", "setText", "setDisabled"],
        data(){
            return{
            }
        },
        computed:{
            isCircular(){
                return this.setCircular || false;
            },
            color(){
                return this.setColor;
            },
            defaultIcon(){
                return this.setDefaultIcon || 'mdi-spin';
            },
            smallIcon(){
                return this.setSmallIcon || 'mdi-emoticon';
            },
            toRouter(){
                return this.setTo;
            },
            text(){
                return this.setText || false;
            },
            isDisabled(){
                return this.setDisabled || false;
            }
        },
        methods:{
            async click(event){
                try {
                    this.setClick(event);
                }
                catch (e) {
                    this.$log.debug('Error: ' + e);
                    this.$emit('ButtonError', e.message)
                }
            }
        }
    }
</script>

<style scoped>

</style>